/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";

import ReactTable from "react-table";
import { DropdownButton, NavItem } from "react-bootstrap";
import { IoFolder, IoEllipsisVertical } from "react-icons/io5";
import { orderBy, uniq, map } from "lodash";
import Badge from "../common/Badge";

import Loading from "../common/Loading";

const ContractTierList = ({ contractTiers, onClickEdit }) => {
  let codesView = (
    <div className="vertical-center -full">
      <Loading active={!contractTiers.length} />
    </div>
  );

  const columns = [
    {
      Header: "Value",
      accessor: "value"
    },
    {
      Header: "Label",
      accessor: "label"
    },
    {
      Header: "Type",
      accessor: "contract_type.label",
      Cell: ({ value }) => value || "--",
      minWidth: 180
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge className="fixed-width" color={value ? "#7AE0FF" : "red"}>
          {value ? "Active" : "Inactive"}
        </Badge>
      )
    },
    {
      Header: "Low SLA",
      accessor: "low_sla"
    },
    {
      Header: "Normal SLA",
      accessor: "normal_sla"
    },
    {
      Header: "High SLA",
      accessor: "high_sla"
    },
    {
      Header: "",
      accessor: "_id",
      maxWidth: 80,
      Aggregated: () => <span />,
      Cell: ({ value }) => (
        <div className="text-center actions">
          <DropdownButton
            title={<IoEllipsisVertical />}
            id="contract-tier-dropdown"
          >
            <NavItem onClick={() => onClickEdit(value)}>
              <IoFolder />
              View
            </NavItem>
          </DropdownButton>
        </div>
      )
    }
  ];

  if (contractTiers.length > 0) {
    codesView = (
      <ReactTable
        className="-highlight pd-20"
        data={orderBy(contractTiers, "label")}
        showPagination={false}
        columns={columns}
        pageSize={uniq(map(contractTiers, "label")).length}
        getTdProps={(state, rowInfo, column) => ({
          onClick: () => {
            if (column.id !== "_id" && rowInfo?.original?._id) {
              onClickEdit(rowInfo.original._id);
            }
          }
        })}
      />
    );
  }

  return <div>{codesView}</div>;
};

ContractTierList.propTypes = {
  contractTiers: PropTypes.array.isRequired,
  onClickEdit: PropTypes.func.isRequired
};

export default ContractTierList;
